"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    orientation: String,
    panes: Array,

    // Events
    collapse: Function,
    contentLoad: Function,
    error: Function,
    expand: Function,
    layoutChange: Function,
    resize: Function
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-layout-vue-wrapper/dist/es/KendoSplitter/SplitterProps.js
// module id = 675
// module chunks = 0